// Developer-only teleport panel. Toggled with the backtick key (`~`). Lists a
// few points of interest and calls back to the caller with the target unit
// direction when a button is clicked.
//
// Intentionally styled with a red/monospace "devtools" look so it's obvious
// it's not part of the shipped UI.

import { isGameInputBlocked } from '../input.js';

let element = null;
let visible = false;
let onTeleport = null;
let poiList = [];
let actionList = [];

function build() {
  const el = document.createElement('div');
  el.className = 'dev-menu hidden';
  el.innerHTML = `
    <div class="dev-header">
      <span class="dev-title">Dev</span>
      <span class="dev-hint"><kbd>~</kbd> close</span>
    </div>
    <div class="dev-section-title">Teleport</div>
    <div class="dev-list"></div>
    <div class="dev-section-title dev-actions-title">Actions</div>
    <div class="dev-actions"></div>
  `;
  document.body.appendChild(el);
  return el;
}

function render() {
  if (!element) return;
  const list = element.querySelector('.dev-list');
  list.innerHTML = poiList.map((poi, i) => `
    <button class="dev-btn" data-index="${i}">${poi.name}</button>
  `).join('');

  list.querySelectorAll('.dev-btn').forEach((btn) => {
    btn.addEventListener('click', () => {
      const i = Number(btn.dataset.index);
      const poi = poiList[i];
      if (!poi || !onTeleport) return;
      // If the POI has a generator fn, call it to produce a fresh direction
      // (e.g. "Random spot"). Otherwise use the static direction.
      const dir = poi.dir instanceof Function ? poi.dir() : poi.dir;
      // Optional tangent override — lets a POI control which direction
      // the player ends up facing (e.g. looking into a cave entrance).
      const tangent = poi.tangent instanceof Function ? poi.tangent()
                    : poi.tangent ?? null;
      onTeleport(dir.clone().normalize(), tangent);
    });
  });

  const actionsContainer = element.querySelector('.dev-actions');
  const actionsTitle     = element.querySelector('.dev-actions-title');
  if (actionList.length === 0) {
    actionsContainer.innerHTML = '';
    actionsTitle.style.display = 'none';
  } else {
    actionsTitle.style.display = '';
    actionsContainer.innerHTML = actionList.map((a, i) => `
      <button class="dev-btn dev-action-btn" data-action-index="${i}">${a.name}</button>
    `).join('');
    actionsContainer.querySelectorAll('.dev-action-btn').forEach((btn) => {
      btn.addEventListener('click', () => {
        const a = actionList[Number(btn.dataset.actionIndex)];
        if (a && typeof a.fn === 'function') a.fn();
      });
    });
  }
}

export function initDevMenu({ pois, onTeleport: onTpCallback, actions = [] }) {
  element = build();
  poiList = pois;
  actionList = actions;
  onTeleport = onTpCallback;
  render();

  addEventListener('keydown', (e) => {
    if (isGameInputBlocked()) return;
    // Use e.code so the toggle works regardless of shift state / layout.
    if (e.code !== 'Backquote') return;
    e.preventDefault();
    visible = !visible;
    element.classList.toggle('hidden', !visible);
  });
}

export function setDevPois(pois) {
  poiList = pois;
  render();
}

export function setDevActions(actions) {
  actionList = actions;
  render();
}
